export default "__VITE_ASSET__ChGGN0qm__"